let forCustomer_data = [
    {
        type: '여성 테니스',
        name: '피케 스판 카라 원피스',
        price: '109,000원',
        imgUrl: '/img/forCustomer1.jpg'
    },
    {
        type: '여성 컴포트핏 테니스',
        name: '피케 카라 맨투맨',
        price: '89,000원',
        imgUrl: '/img/forCustomer2.jpg'
    },
    {
        type: '여성 테니스',
        name: '우븐 플리츠스커트',
        price: '99,000원',
        imgUrl: '/img/forCustomer3.jpg'
    },
    {
        type: '여성 테니스',
        name: '컬러블럭 바람막이',
        price: '149,000원',
        imgUrl: '/img/forCustomer4.jpg'
    },
    {
        type: '여성 테니스',
        name: '글로벌 화이트컬렉션 플리츠스커트',
        price: '119,000원',
        imgUrl: '/img/forCustomer5.jpg'
    },
    {
        type: '여성 테니스',
        name: '피케 스판 카라 원피스',
        price: '109,000원',
        imgUrl: '/img/forCustomer6.jpg'
    },
    {
        type: '여성 테니스',
        name: '우븐 플리츠스커트',
        price: '99,000원',
        imgUrl: '/img/forCustomer7.jpg'
    },
    {
        type: '여성 테니스',
        name: '면혼방 가디건',
        price: '129,000원',
        imgUrl: '/img/forCustomer8.jpg'
    },
    {
        type: '여성 테니스',
        name: '우븐 버뮤다 팬츠',
        price: '89,000원',
        imgUrl: '/img/forCustomer9.jpg'
    },
    {
        type: '남녀공용 컴포트핏 라이프스타일',
        name: '뉴헤리티지 카라맨투맨',
        price: '79,000원',
        imgUrl: '/img/forCustomer10.jpg'
    },
    {
        type: '여성 레귤러핏 테니스',
        name: '피케 스판 긴팔 카라티',
        price: '79,000원',
        imgUrl: '/img/forCustomer11.jpg'
    },
    {
        type: '여성 테니스',
        name: '컬러블럭 바람막이',
        price: '149,000원',
        imgUrl: '/img/forCustomer12.jpg'
    }
]


export default forCustomer_data;